import EmailIcon from "@mui/icons-material/Email";
import "./AboutSection.css";

const AboutSection = () => (
  <section className="about-section" id="apropos">
    <div className="about-inner">
      <div className="about-header">
        <div className="about-eyebrow">
          {/* <ScienceIcon fontSize="inherit" /> */}
          À propos
        </div>
        <h2 className="about-heading">UNE COOPÉRATION POUR DES SOLUTIONS SCIENTIFIQUES <br /> DANS LA LUTTE CONTRE LES FEUX DE FORÊT</h2>
      </div>

      <div className="about-grid">
        <div>
          <a
            href="https://climateinstitute.edhec.edu"
            target="_blank"
            rel="noopener noreferrer"
            className="partner-card partner-card--link"
          >
            <img
              src="/images/edhec.jpg"
              alt="EDHEC Climate Institute"
              className="partner-logo partner-logo--edhec"
            />
            <p className="partner-desc">
              Centre de recherche sur les impacts économiques du changement climatique.
            </p>
            <p className="partner-desc partner-about">
              L'EDHEC Climate Institute (ECI) est le centre de recherche de l'EDHEC
              Business School dédié aux enjeux du changement climatique et de la
              finance climatique. Sa mission est d'accompagner les décideurs publics
              et privés dans la compréhension et la gestion des risques climatiques
              ainsi que dans le financement de la transition vers une économie bas
              carbone et résiliente. ECI développe des travaux de recherche reconnus
              internationalement sur les risques physiques et de transition liés au
              changement climatique.
            </p>
          </a>
          <a
            href="https://climate-innov.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="partner-card partner-card--link"
          >
            <img
              src="/images/cid.png"
              alt="Climate Innov"
              className="partner-logo"
            />
            <p className="partner-desc">
              Entreprise de recherche franco-tunisienne spécialisée dans les technologies climatiques.
            </p>
            <p className="partner-desc partner-about">
              Climate Innov est une startup franco-tunisienne dédiée à l'innovation
              pour la lutte contre les risques climatiques. Elle conçoit des solutions
              combinant technologie spatiale, intelligence artificielle et modélisation
              scientifique pour, entre autres, mieux anticiper et combattre les feux de
              forêt.
            </p>
          </a>
        </div>

        <div>
          <p className="about-right-text">
            Le projet ensemblepourlaforet.fr vise à rendre accessible, gratuitement, une information de
            pointe sur le risque incendie sur tout le territoire français.
          </p>
          <hr className="about-divider" />
          <p className="about-disclaimer">
            Les informations proposées dans le cadre de cette opération sont toujours
            soumises à un risque d'estimation, avec des imprécisions liées aux
            conditions d'utilisation des modèles mis en œuvre et à la qualité des
            informations collectées. Ni l'EDHEC Climate Institute, ni Climate Innov
            ne sauraient être tenus responsables des conséquences morales, humaines
            et matérielles de l'utilisation de leurs services.
          </p>
          <ul className="contact-list">
            <li>
              <a
                href="mailto:info@ensemblepourlaforet.fr?subject=Demandes%20sp%C3%A9cifiques"
                className="contact-link"
              >
                <EmailIcon fontSize="inherit" />
                info@ensemblepourlaforet.fr
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;